export const HatIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41786 22.2049C6.60289 22.4716 9.84649 27.103 15.6697 27.6472C21.6562 28.1914 20.2956 25.2308 26.2821 24.3818C29.1665 23.9737 30.6958 24.4635 31.2509 24.8227C31.4606 24.9595 31.7401 24.914 31.8954 24.7176C32.0508 24.5213 32.0309 24.2388 31.8496 24.0662C30.7611 23.043 28.1053 21.3593 25.4604 19.4708L24.7635 19.3412L23.2314 19.245H22.1558L20.5258 19.5544L18.4316 19.9808L15.1837 20.7959L11.6809 21.5652L9.11439 21.9747L6.41786 22.2049Z"
        fill="#FFAB00"
      />
      <path
        opacity="0.3"
        d="M0.344324 17.9653C0.344324 23.3096 1.3838 22.5804 4.40425 22.3192C8.21384 21.9872 8.05601 22.5913 18.3909 20.0062C20.5678 19.462 23.6318 19.0919 25.4658 19.462C25.4658 19.462 25.0522 14.319 22.5379 10.7217C19.1474 5.86719 11.3159 5.86719 11.3159 5.86719C9.20765 6.2293 7.19498 7.01622 5.40019 8.18015C1.96612 10.4169 0.344324 13.8564 0.344324 17.9653Z"
        fill="#FFAB00"
      />
      <path
        opacity="0.8"
        d="M11.3159 5.86719C18.9732 7.22775 20.3283 17.3612 20.5351 19.5871C22.1619 19.2846 23.8268 19.246 25.4658 19.4728C25.4658 19.4728 25.0522 14.3299 22.5379 10.7326C19.1474 5.86719 11.3159 5.86719 11.3159 5.86719Z"
        fill="#FFAB00"
      />
      <path
        opacity="0.5"
        d="M9.13898 21.9926C13.5853 21.4484 17.8466 19.9844 20.5405 19.5871C20.3283 17.3612 18.9732 7.22775 11.3159 5.86719C5.3294 8.96384 8.59475 20.2184 9.13898 21.9926Z"
        fill="#FFAB00"
      />
      <path
        d="M9.68344 6.27547C9.68344 6.01424 9.62902 5.80743 9.62902 5.69315C9.62902 3.95162 12.6985 3.73937 12.8944 5.52443L12.9434 5.98159L9.68344 6.27547Z"
        fill="#FFAB00"
      />
    </svg>
  );
};
